module.exports = __webpack_public_path__ + "img/es.ae089b9a.svg";